import React from "react";
import "./GetReady.css";
const GetReady = () => {
  return (
    <section className="get-ready-section">
      <div className="containerer">
        <div className="mt-auto row">
          <div className="col">
            <div className="tile--with-shadow text-center get-ready-badge">
              <div className="tile__main">
                Ready to launch your project?
              </div>
              <a
                className="round-button light large wide btn btn-main nop"
                href="https://1jn712lieeo.typeform.com/to/hypE5Z7h" target="_blank"
              >
                Apply here
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetReady;
